export const DEFAULT_TIMEZONE = 'UTC'
export const DATE_FORMAT = 'yyyy-MM-dd'
